import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../lib/api";
import { t } from "../lib/i18n";
import { qk } from "./keys";
import { invalidateProject } from "./projects";
import type { Assignment, EndedAssignment } from "./types";

export function useAssign() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: { person: number; stream_id: number; start_date: string | null }) =>
      api<Assignment>("/api/assignments", { body: input }),
    meta: { errorTitle: t("Assignment not created") },
    onSuccess: (assignment) => {
      invalidateProject(client, assignment.project);
      void client.invalidateQueries({ queryKey: qk.admin });
      void client.invalidateQueries({ queryKey: qk.myAssignments });
    },
  });
}

export function useEndAssignment() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, end_date }: { id: number; end_date: string | null }) =>
      api<EndedAssignment>(`/api/assignments/${id}/end`, { body: { end_date } }),
    meta: { errorTitle: t("Assignment not ended") },
    onSuccess: (assignment) => {
      invalidateProject(client, assignment.project);
      void client.invalidateQueries({ queryKey: qk.admin });
      void client.invalidateQueries({ queryKey: qk.myAssignments });
    },
  });
}
